module.exports = __webpack_public_path__ + "media/data-portal/layersneeded-c9275ba8.png";